<template>
  <el-container>
   <el-main> 
     <el-tabs type="card" ref="tabs" style="min-width:800px;">
      <el-tab-pane :label="$t('deviceDetail.lockInfo')">
        <el-col :span="8">
          <el-form class="demo-ruleForm">
            <el-form-item :label="$t('deviceDetail.deviceName')">
             {{this.lockDetail.deviceName}}
            </el-form-item>

            <el-form-item :label="$t('deviceDetail.number')">
              {{this.lockDetail.deviceId}}
            </el-form-item>

            <el-form-item :label="$t('deviceDetail.bindTime')">
              {{(this.lockDetail.bindTime==""||this.lockDetail.bindTime==undefined)?'':this.$util.formartDateTime(this.lockDetail.bindTime)}}
            </el-form-item>
            
            <el-form-item :label="$t('deviceDetail.bindInfo')">
              {{ this.lockDetail.roomName }}{{$t('deviceDetail.room')}}
            </el-form-item>

            <el-form-item :label="$t('deviceDetail.lockModle')">
              {{this.lockDetail.modelNo}}
            </el-form-item>

          

          </el-form>
        </el-col>
        <el-col :span="8" style="padding:3px;">
           <el-form class="demo-ruleForm">
                 <el-form-item :label="$t('deviceDetail.supportOpenType')">
              {{this.$util.lockValidTypesFormat(this.lockDetail.validTypes)}}
            </el-form-item>

            <el-form-item :label="$t('deviceDetail.softwareVersion')">
              {{this.lockDetail.enVersion}}
            </el-form-item>

            <el-form-item :label="$t('deviceDetail.hardwareVersion')">
              {{this.lockDetail.hardwareVersion}}
            </el-form-item>

            <el-form-item :label="$t('deviceDetail.supportCMCType')">
              {{this.$util.lockCommTypesFormat(this.lockDetail.commTypes)}}
            </el-form-item>

            <el-form-item :label="$t('deviceDetail.powerType')">
              {{this.$util.lockPowerTypeFormat(this.lockDetail.powerType)}}
            </el-form-item>
           </el-form>  
        </el-col>
      </el-tab-pane>

      <el-tab-pane :label="$t('deviceDetail.authRecord')">
        <el-table
          :data="authData"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          empty-text="No Data"
          border
          style="margin-top: 5px"
        >
          <el-table-column
            type="index"
            :label="$t('deviceDetail.order')"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="validType"
            :formatter="this.$util.authValidTypeFormat"
            :label="$t('deviceDetail.authType')"
            align="center"
            width="120"
          ></el-table-column>
           <el-table-column
            prop="authorizationUserId"
            :label="$t('deviceDetail.keyAuthUserId')"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="authorizationName"
            :label="$t('deviceDetail.authName')"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="status"
            :formatter="this.$util.authStatusFormat"
            :label="$t('deviceDetail.authStatus')"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="validData"
            :formatter="this.$util.validDataFormat"
            :label="$t('deviceDetail.authInfo')"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="beginTime"
            :formatter="this.$util.authBeginTimeFormat"
            :label="$t('deviceDetail.beginTime')"
            width="160"
            align="center"
          >
           <template slot-scope="scope">
             {{scope.row.isLimit==1?$util.formartDateTime(scope.row.beginTime):""}}
            </template>
          </el-table-column>
          <el-table-column
            prop="endTime"
            :formatter="this.$util.datetimeFormat"
            :label="$t('deviceDetail.endTime')"
            width="160"
            align="center"
          >
           <template slot-scope="scope">
             {{scope.row.isLimit==1?$util.formartDateTime(scope.row.endTime):""}}
            </template>
          </el-table-column>
          <el-table-column
            prop="validData"
            :formatter="this.$util.timeoffFormat"
            :label="$t('deviceDetail.timeOff')"
             width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            :formatter="this.$util.datetimeFormat"
            :label="$t('deviceDetail.createTime')"
            align="center"
            width="160"
          ></el-table-column>
          <el-table-column prop :label="$t('deviceDetail.operate')" width="100px" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" icon="el-icon-delete" :title="$t('deviceDetail.delete')" @click="delAuth(scope.$index, scope.row)"></el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <Pagings
          :total="authTotal"
          :offset="authPageData.offset"
          :pageSize="authPageData.pageNumber"
          @handleSizeChangeSub="authHandleSizeChange"
          @handleCurrentChangeSub="authHandleCurrentChange"
          style="margin-top: 10px"
        ></Pagings>
      </el-tab-pane>

      <el-tab-pane :label="$t('deviceDetail.record')">
       
      </el-tab-pane>

      <el-tab-pane :label="$t('deviceDetail.aleamLog')">
       
      </el-tab-pane>
    </el-tabs>
   </el-main>
  </el-container>   
</template>
<script>
export default {
  data() {
    return {
       deviceId:this.$route.query.deviceId,
       lockDetail:[],
       authData: [],
       
    };
  },
  created() {
     this.getLockDetail();
  },
  methods: {
    getLockDetail(){
      var formData = new FormData();
      formData.append("deviceId", this.deviceId);
      this.$server
        .exam("/customer/apartment/getLockDetail", formData)
        .then(data => {
          if (data.code == 200) {
            this.lockDetail = data.data;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    authPower() {
      var formData = new FormData();
      formData.append("deviceId", this.deviceId);
      formData.append("pageNo", this.authPageData.offset);
      formData.append("pageSize", this.authPageData.pageNumber);
      // if(this.authStatus!=""){
      //    formData.append("status",parseInt(this.authStatus));
      // }else{
      //   formData.append("status","");
      // }
      this.$server
        .exam("/customer/apartment/listLockAuthorization", formData)
        .then(data => {
          if (data.code == 200) {
            this.authData = data.data.records;
            this.authTotal = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
  }  
  
}
</script>


// WEBPACK FOOTER //
// src/components/statistics/deviceStaDetail.vue